import Store from 'store/store';

const getVibeFromHoldingId = (id) => {
	if (!id) return '';
	let vibe = id.replace('holding', '');
	return vibe[0].toLowerCase() + vibe.substring(1);
};

const getVibeFromARId = (id) => {
	if (!id) return;
	return id.replace('AR', '');
};

// Holding page
Store.on('TRACK_HOLDING_PAGE_VIEW', ({ region, id }) => {
	const idNumbers = {
		holdingSliceOfLife: 1,
		holdingSciFi: 2,
		holdingPop: 3
	};
	Store.emit('POWSTER_GA_PAGE_VIEW_TRACK', `${region}/${idNumbers[id]}/`);
});

Store.on('CALENDAR_CLICKED', ({ label }) => {
	const id = Store.get().activePage;
	const vibe = getVibeFromHoldingId(id);
	Store.emit('POWSTER_GA_EVENT_TRACK', 'calendar-reminder-click', `detail-${vibe}`, label);
});

Store.on('TRACK_PRIVACY_POLICY_CLICK', ({ id }) => {
	let eventCategory = 'misc';
	if (id.startsWith('holding')) {
		const vibe = getVibeFromHoldingId(id);
		eventCategory = `detail-${vibe}`;
	}
	Store.emit('POWSTER_GA_EVENT_TRACK', 'privacy-policy-click', eventCategory, '-');
});

Store.on('CLICKED_SHARE', ({ label, activePage }) => {
	if (activePage.startsWith('holding')) {
		const vibe = getVibeFromHoldingId(activePage);
		Store.emit('POWSTER_GA_EVENT_TRACK', 'site-share', `detail-${vibe}`, `detail-${label}`);
	} else if (activePage === 'portals') {
		Store.emit('POWSTER_GA_EVENT_TRACK', 'master-page-share', 'sharing', `detail-${label}`);
	} else {
		Store.emit('POWSTER_GA_EVENT_TRACK', `${activePage}-site-share`, 'sharing', `detail-${label}`);
	}
});

Store.on('TRACK_HOLDING_UNMUTE', ({ id }) => {
	const vibe = getVibeFromHoldingId(id);
	Store.emit('POWSTER_GA_EVENT_TRACK', 'play-sound', `detail-${vibe}`, '-');
});
Store.on('TOGGLE_MUTE', ({ muted, id }) => {
	let pageClean = id === 'portals' ? 'master' : id;
	Store.emit('POWSTER_GA_EVENT_TRACK', `${pageClean}-${muted ? 'mute' : 'unmute'}-sound`, 'misc', '-');
});

// Portals
// Handled in CLICKED_SHARE
// Store.on('SHARE', () => {
// 	Store.emit('POWSTER_GA_EVENT_TRACK', 'master-page-share', 'sharing', '-');
// });
Store.on('PORTAL_CLICK', ({ id }) => {
	const vibe = getVibeFromHoldingId(id);
	Store.emit('POWSTER_GA_EVENT_TRACK', 'portal-selection', 'master-qr-page', vibe);
});

// Individual portal pages
function trackProgress(pageId, progress) {
	if (!['sliceOfLife', 'sciFi', 'pop'].includes(pageId)) {
		return;
	}
	Store.emit('POWSTER_GA_EVENT_TRACK', `${pageId}-progress`, 'microsite-experience', `${progress}/6`);
}
Store.on('LANDING', id => trackProgress(id, 1));
Store.on('SET_ACTIVE_PAGE', id => trackProgress(id, 1));
Store.on('INTRO_VIDEO_PLAYING', id => trackProgress(id, 2));
Store.on('PORTAL_ANIMATION_STARTED', id => trackProgress(id, 3));
Store.on('SCROLL_TO_CONTENT', id => trackProgress(id, 4));
Store.on('SCROLL_TO_GIFT', id => trackProgress(id, 5));
Store.on('PORTALS_BUTTON_CLICKED', ({ id }) => trackProgress(id, 6));
Store.on('INTERSTITIAL_BUTTON_CLICKED', (data) => {
	const vibe = getVibeFromHoldingId(data?.id);
	Store.emit('POWSTER_GA_EVENT_TRACK', `${vibe}-start-click`, 'text-intro-page', '-');
});
Store.on('SKIPPED_PORTAL', ({ progress, id }) => {
	// Round to the nearest 25%
	let progressRounded = 100 * Math.round(progress * 4) / 4;
	Store.emit('POWSTER_GA_EVENT_TRACK', `${id}-skip-animation`, 'animation-portal', progressRounded + '%');
});
Store.on('CLOSE_CONTENT_VIDEO', ({ id, video, progress }) => {
	// Round to the nearest 25%
	let progressRounded = 100 * Math.round(progress * 4) / 4;
	Store.emit('POWSTER_GA_EVENT_TRACK', `${id}-video-watch`, 'multi-content-page', `video-${video}-${progressRounded}%`);
});


// Gift pages
Store.on('GIFT_DOWNLOAD', ({ id }) => {
	Store.emit('POWSTER_GA_EVENT_TRACK', `${id}-token-downloads`, 'gift-page', '-');
});
Store.on('GIFT_PLAYLIST', ({ id }) => {
	Store.emit('POWSTER_GA_EVENT_TRACK', `${id}-playlist-selection`, 'gift-page', '-');
});
Store.on('PORTALS_BUTTON_CLICKED', ({ id }) => {
	Store.emit('POWSTER_GA_EVENT_TRACK', `${id}-explore-more-selection`, 'gift-page', '-');
});

Store.on('OPEN_SURVEY', ({ id }) => {
	Store.emit('POWSTER_GA_EVENT_TRACK', `${id}-survey-selection`, 'gift-page', '-');
});


// AR
const arCategory = 'AR';
const trackCameraPermissions = (id, permission) => {
	const vibe = getVibeFromARId(id);
	Store.emit('POWSTER_GA_EVENT_TRACK', `${vibe}-device-permission`, arCategory, permission);
};

Store.on('TRACK_AR_PAGE_VIEW', ({ id }) => {
	const idNumbers = {
		sliceOfLifeAR: 1,
		sciFiAR: 2,
		popAR: 3
	};
	Store.emit('POWSTER_GA_PAGE_VIEW_TRACK', `/${idNumbers[id]}/`);
});

Store.on('CAMERA_PERMISSIONS_ACCEPTED', ({ id }) => {
	trackCameraPermissions(id, 'allow');
});

Store.on('CAMERA_PERMISSIONS_DENIED', ({ id }) => {
	trackCameraPermissions(id, 'deny');
});

Store.on('TRACK_AR_FOOTER_CLICK', ({ id, link }) => {
	const vibe = getVibeFromARId(id);
	Store.emit('POWSTER_GA_EVENT_TRACK', `${vibe}-footer-click`, arCategory, link.$copy);
});

Store.on('INTERSTITIAL_BUTTON_CLICKED', ({ id }) => {
	const arStore = Store.get().arIntro || {};
	const cameFromFinishingAR = arStore.ended && !arStore.ARskipped;
	if (cameFromFinishingAR) {
		Store.emit('POWSTER_GA_EVENT_TRACK', `${id}-start-click`, arCategory, '-');
	}
});

Store.on('TRACK_ERROR_DEVICE_DETAILS', ({ deviceData, id }) => {
	const vibe = getVibeFromARId(id);
	const { manufacturer, model, os, osVersion, browser } = deviceData;
	const label = manufacturer + model + os + osVersion + '-' + browser.name + browser.version;
	Store.emit('POWSTER_GA_EVENT_TRACK', `${vibe}-unsupported`, arCategory, label);
});
